import { historyApi } from "config/api/history";
import { HistoryItem } from "./type";

export const fetchHistoryData = async (account: string, fromDate: string, toDate: string, search: string, sort:string, skip: number, limit: number, chainId:string): Promise<{dataHistory:HistoryItem}> => {
    if(account?.length){
        try {
            const res = await historyApi.history({fromDate, toDate, search, sort, skip, limit, chainId})
            return {
                dataHistory: {
                    total: res?.data?.total,
                    orders: res?.data?.orders
                }
            }
        } catch (error) {
            console.log(error)
            return {
                dataHistory: null
            }
        }
    }
    return {
        dataHistory: null
    }
}
